import legal_case_example_tutorial_1 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_1.json';
import legal_case_example_tutorial_2 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_2.json';
import legal_case_example_tutorial_3 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_3.json';
import legal_case_example_tutorial_4 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_4.json';
import legal_case_example_tutorial_5 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_5.json';
import legal_case_example_tutorial_6 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_6.json';
import legal_case_example_tutorial_7 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_7.json';
import legal_case_example_tutorial_8 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_8.json';
import legal_case_example_tutorial_9 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_9.json';
import legal_case_example_tutorial_10 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_10.json';
import legal_case_example_tutorial_11 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_11.json';
import legal_case_example_tutorial_12 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_12.json';
import legal_case_example_tutorial_13 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_13.json';
import legal_case_example_tutorial_14 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_14.json';
import legal_case_example_tutorial_15 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_15.json';
import legal_case_example_tutorial_16 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_16.json';
import legal_case_example_tutorial_17 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_17.json';
import legal_case_example_tutorial_18 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_18.json';
import legal_case_example_tutorial_19 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_19.json';
import legal_case_example_tutorial_20 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_20.json';
import legal_case_example_tutorial_21 from '../tutorial-trees/legal-case-example-tutorial-trees/legal_case_example_21.json';

const legalCaseExampleTutorialFiles = [
    legal_case_example_tutorial_1,
    legal_case_example_tutorial_2,
    legal_case_example_tutorial_3,
    legal_case_example_tutorial_4,
    legal_case_example_tutorial_5,
    legal_case_example_tutorial_6,
    legal_case_example_tutorial_7,
    legal_case_example_tutorial_8,
    legal_case_example_tutorial_9,
    legal_case_example_tutorial_10,
    legal_case_example_tutorial_11,
    legal_case_example_tutorial_12,
    legal_case_example_tutorial_13,
    legal_case_example_tutorial_14,
    legal_case_example_tutorial_15,
    legal_case_example_tutorial_16,
    legal_case_example_tutorial_17,
    legal_case_example_tutorial_18,
    legal_case_example_tutorial_19,
    legal_case_example_tutorial_20,
    legal_case_example_tutorial_21,
];

export default legalCaseExampleTutorialFiles;